/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { CommerceSpec } from './commerceSpec';


export interface VcdsDeploymentPatchTenantSpec { 
    commerce?: CommerceSpec;
}

